import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["label"];
  
  connect() {
    const getNumber = this.labelTarget.value.split("-");
    this.counter = Number(getNumber[getNumber.length - 1].trim());
    this.prevCounter = this.counter;
  }

  count(e){
    if(e.target.checked) {
      this.counter += 1;
    }
    else {
      this.counter -= 1;
    }

    if(this.counter > 0){
      this.labelTarget.value = this.labelTarget.value.replace(this.prevCounter, this.counter);
  
      this.prevCounter = this.counter;
    }
  }
}
